import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 3.2rem;
  border: .1rem solid ${(props) => props.theme.colors.darkBlue};
  border-radius: 1.2rem;

`;
export const Info = styled.div`

  display: flex;
  align-items: center;

`;
export const MetaInfo = styled.div`

  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 1.6rem;

`;
export const IconBlock = styled.div`

  width: 6rem;
  height: 6rem;
  border-radius: 1.2rem;
  background-color: ${(props) => props.theme.colors.pink100};
  display: flex;
  justify-content: center;
  align-items: center;

`;
export const Title = styled.span`

  ${(props) => props.theme.fonts.interSemibold18};
  color: ${(props) => props.theme.colors.white100};
  display: block;

`;
export const Description = styled.span`

  ${(props) => props.theme.fonts.interMedium13};
  color: ${(props) => props.theme.colors.secondary};

`;
export const Btns = styled.div`

  display: flex;
  align-items: center;
  gap: 1.2rem;

`;